import type { SessionLifecycleObserver } from '@core/ports/SessionLifecycleObserver';
import { readSessionLifecycleTiming } from '@infrastructure/http/sessionLifecycleHeaders';

export class SessionLifecycleTransportBridge {
  public constructor(private readonly sessionLifecycleObserver?: SessionLifecycleObserver) {}

  public markSessionRequired(message: string): void {
    this.sessionLifecycleObserver?.markSessionRequired(message);
  }

  public applyResponseHeaders(headers: Headers): void {
    const timing = readSessionLifecycleTiming(headers);
    if (timing) {
      this.sessionLifecycleObserver?.updateFromTiming(timing);
    }
  }
}